module.exports = __webpack_public_path__ + "img/super_assistant.ed48e818.png";